<template>
  <el-dialog class="refuse-dialog" :title="tip" :visible.sync="isShow" width="32%">
    <div v-if="type === typeCode.cancel">
      <span>取消原因：</span>
      <el-select v-model="select.label" placeholder="请选择取消订单的原因" @change="change">
        <el-option
          v-for="item in reasonList"
          :key="item.reasonId"
          :label="item.reasonText"
          :value="item.reasonId"
        ></el-option>
      </el-select>
      <div class="m-t20 c-9 f-12">
        <span>温馨提示：</span>
        <ul class="temp m-lr15">
          <li class="m-t10">订单一旦取消，限时特价，购买资格等购买优惠可能一并取消，不可恢复；</li>
          <li class="m-t10">订单所用红包，优惠券暂不支持退回，请谨慎使用。</li>
        </ul>
      </div>
    </div>
    <div v-else-if="type === typeCode.refundAll">
      <span>退款原因：</span>
      <el-select v-model="select.label" placeholder="请选择整单退款的原因" @change="change">
        <el-option
          v-for="item in reasonList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div v-else-if="type === typeCode.cancelPicker">
      <span>取消原因：</span>
      <el-select
        v-model="select.label"
        style="width: 250px"
        placeholder="请选择取消提单的原因"
        @change="change"
      >
        <el-option
          v-for="item in reasonList"
          :key="item.reasonId"
          :label="item.reasonText"
          :value="item.reasonId"
        ></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">再想一想</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const typeCode = {
  cancel: 'cancel',
  refundAll: 'refundAll',
  cancelPicker: 'cancelPicker'
}

export default {
  name: 'RefuseDialog',
  components: {},
  props: {},
  data() {
    return {
      typeCode,
      type: 'cancel',
      select: {
        id: null,
        label: ''
      },
      isShow: false,
      reasonList: []
    }
  },
  computed: {
    tip() {
      switch (this.type) {
        case typeCode.cancel:
          return '取消订单'
        case typeCode.refundAll:
          return '整单退款'
        case typeCode.cancelPicker:
          return '取消提单'
        default:
          return '提示'
      }
    }
  },
  created() {},
  methods: {
    async showDialog(isShow, type = typeCode.cancel) {
      if (isShow) {
        this.type = type
        if (type === typeCode.cancel) {
          // 取消订单
          let { success, data } = await this.$get('trademanager.getCloseOrderReasonList', {
            orderBizType: 'STEELS'
          })
          if (success) {
            this.reasonList = data.value
          }
        } else if (type === typeCode.refundAll) {
          // 整单退款
          this.reasonList = [] // 缺少接口
        } else if (type === typeCode.cancelPicker) {
          // 取消发货
          let { success, data } = await this.$get('lgcenter.getSellerCloseOrderReasonList')
          if (success) {
            this.reasonList = data[0].value
          }
        }
      }
      this.isShow = isShow
      this.select.id = null
      this.select.label = ''
    },
    change(val) {
      this.reasonList.forEach(item => {
        if (item.reasonId === val) {
          this.select.id = item.reasonId
          this.select.label = item.reasonText
        }
      })
    },
    submit() {
      if (this.select.id === null) {
        this.$message.error('请选择原因')
        return
      }
      this.$emit('submit', this.select)
      this.showDialog(false)
    }
  }
}
</script>

<style lang="less" scoped>
.refuse-dialog {
  z-index: 999;
  .temp {
    list-style-type: disc;
    line-height: 1.5;
  }
}
</style>
